import React from "react"

import {MC} from './MC.js'

class Media extends React.Component {

  onImageLoad = () => {
    if (MC.isModelerActive(this.props.data) && MC.isFunction(modelerChanged)) {
      modelerChanged("resize")
    }
  }

  openBlob = (e, value, contentType, target) => {
    e.preventDefault()
    if (MC.isNullOrEmpty(value)) {
      return
    }
    const uri = window.URL.createObjectURL(MC.base64ToBlob(value, contentType || undefined))
    window.open(uri, target)
    setTimeout(() => window.URL.revokeObjectURL(uri), 60000)
  }

  render() {
    const field = this.props.data
    let cssclass = MC.getFieldParamValue(field.param, '@cssClass')
    let css = MC.styleObjectFromString(MC.getFieldParamValue(field.param, '@css'))
    const contentType = MC.getFieldParamValue(field.param, '@contentType')
    const showAsLink = MC.getFieldParamValue(field.param, '@showAsLink')
    const value = MC.getFieldParamValue(field.param, 'value')
    if (showAsLink == true || field.widget == 'defaultviewer') {
      let fileName = MC.getFieldParamValue(field.param, '@fileName')
      if (MC.isNull(fileName)) {
        fileName = "..."
      }
      let target = MC.getFieldParamValue(field.param, '@target')
      target = (['blank', 'parent', 'top'].indexOf(target) > -1) ? '_' + target : '_blank'
      const download = MC.getFieldParamBooleanValue(field.param, '@download') !== false
      let uri = MC.getFieldParamValue(field.param, '@url')
      if (!MC.isNull(uri)) {
        uri = MC.rebaseUrl(field.flow, uri)
      } else if (download) {
        uri = 'data:' + contentType + ';base64,' + value
      } else {
        // browsers block top-level navigation to data: URIs, so base64 content is opened through a blob URL
        return <a href="#" onClick={(e) => this.openBlob(e, value, contentType, target)} data-widget-i-name={field.id} className={cssclass} style={css}><i className="file icon"/>{fileName}</a>
      }
      return <a href={uri} download={download ? fileName : undefined} target={target} data-widget-i-name={field.id} className={cssclass} style={css}><i className="file icon"/>{fileName}</a>
    } else if (field.widget == 'imageviewer') {
      cssclass = MC.classes('mnc image', cssclass, {'centered': this.props.halign == 'center', 'right aligned': this.props.halign == 'right'})
      let uri = MC.getFieldParamValue(field.param, '@url')
      if (!MC.isNullOrEmpty(uri)) {
        uri = MC.rebaseUrl(field.flow, uri)
      } else if (!MC.isNullOrEmpty(value)) {
        uri = 'data:' + contentType + ';base64,' + value
      }
      if (MC.isNullOrEmpty(uri)) {
        return <span className={cssclass} style={css} data-widget-i-name={field.id}/>
      } else {
        return <img className={cssclass} style={css} src={uri} data-widget-i-name={field.id} onLoad={this.onImageLoad}/>
      }
    } else if (field.widget == 'pdfviewer') {
      let uri = MC.getFieldParamValue(field.param, '@url')
      if (!MC.isNull(uri)) {
        uri = MC.rebaseUrl(field.flow, uri)
      } else if (!MC.isNull(value)) {
        uri = 'data:application/pdf;base64,' + value
      }
      if (MC.isNull(uri)) {
        return <span className={cssclass} style={css} data-widget-i-name={field.id}/>
      } else {
        return <iframe className={cssclass} src={uri} width="100%" style={{...css, height: MC.getFieldParamValue(field.param, '@height')}} data-widget-i-name={field.id}/>
      }
    } else if (field.widget == 'videoviewer') {
      let uri = MC.getFieldParamValue(field.param, '@url')
      if (!MC.isNull(uri)) {
        uri = MC.rebaseUrl(field.flow, uri)
      } else if (!MC.isNull(value)) {
        uri = 'data:' + contentType + ';base64,' + value
      }
      if (MC.isNull(uri)) {
        return <span className={cssclass} style={css} data-widget-i-name={field.id}/>
      } else {
        let controls = MC.getFieldParamBooleanValue(field.param, '@controls')
        let autoplay = MC.getFieldParamBooleanValue(field.param, '@autoplay')
        let muted = MC.getFieldParamBooleanValue(field.param, '@muted')
        muted = !autoplay ? muted : true
        let loop = MC.getFieldParamBooleanValue(field.param, '@loop')
        return <video className={cssclass} style={css} data-widget-i-name={field.id} autoPlay={autoplay} muted={muted} controls={controls} loop={loop}><source src={uri} type={contentType}/>Your browser does not support the video tag.</video>
      }
    } else if (field.widget == 'audioviewer') {
      let uri = MC.getFieldParamValue(field.param, '@url')
      if (!MC.isNull(uri)) {
        uri = MC.rebaseUrl(field.flow, uri)
      } else if (!MC.isNull(value)) {
        uri = 'data:' + contentType + ';base64,' + value
      }
      if (MC.isNull(uri)) {
        return <span className={cssclass} style={css} data-widget-i-name={field.id}/>
      } else {
        let controls = MC.getFieldParamBooleanValue(field.param, '@controls') || true
        let autoplay = MC.getFieldParamBooleanValue(field.param, '@autoplay') || false
        let muted = MC.getFieldParamBooleanValue(field.param, '@muted') || false
        muted = !autoplay ? muted : true
        let loop = MC.getFieldParamBooleanValue(field.param, '@loop') || false
        return <audio className={cssclass} style={css} data-widget-i-name={field.id} autoPlay={autoplay} muted={muted} controls={controls} loop={loop}><source src={uri} type={contentType}/>Your browser does not support the audio tag.</audio>
      }
    }
  }

}

export {Media}